import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";
import { config } from "../config";

const redirectUri = `${window.location.origin}/auth/callback`;
const postLogoutRedirectUri = `${window.location.origin}/`;

export const userManager = new UserManager({
  authority: config.authority,
  client_id: config.clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  response_type: "code",
  scope: config.scope,
  automaticSilentRenew: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

export async function currentUser(): Promise<User | null> {
  const user = await userManager.getUser();
  if (!user || user.expired) {
    return null;
  }

  return user;
}

export function login(): Promise<void> {
  return userManager.signinRedirect();
}

export function completeLogin(): Promise<User> {
  return userManager.signinRedirectCallback();
}

export function logout(): Promise<void> {
  return userManager.signoutRedirect();
}
